'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SaveToCollectionDialog } from './SaveToCollectionDialog';

interface SaveToCollectionButtonProps {
  momentId?: string;
  postId: string;
  startTime: number;
  endTime: number;
  title?: string;
  description?: string;
  addedFromSearch?: boolean;
  searchQuery?: string;
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  showLabel?: boolean;
  onSaved?: () => void;
}

export function SaveToCollectionButton({
  momentId,
  postId,
  startTime,
  endTime,
  title,
  description,
  addedFromSearch = false,
  searchQuery,
  variant = 'ghost',
  size = 'sm',
  className,
  showLabel = false,
  onSaved,
}: SaveToCollectionButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleSaved = () => {
    setIsSaved(true);
    setDialogOpen(false);
    onSaved?.();
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={cn(
          'transition-all',
          isSaved && 'text-primary',
          className
        )}
        onClick={() => setDialogOpen(true)}
      >
        {isSaved ? (
          <BookmarkCheck className={cn('h-4 w-4', showLabel && 'mr-2')} />
        ) : (
          <Bookmark className={cn('h-4 w-4', showLabel && 'mr-2')} />
        )}
        {showLabel && (isSaved ? 'Saved' : 'Save')}
      </Button>

      <SaveToCollectionDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        momentData={{
          momentId,
          postId,
          startTime,
          endTime,
          title,
          description,
          addedFromSearch,
          searchQuery,
        }}
        onSaved={handleSaved}
      />
    </>
  );
}
